import React from "react";
import { LucideBookOpen } from "lucide-react";
import SelectCourseCard from "./SelectCourseCard";
import HeaderComponent from "components/card/HeaderComponent";

export default function ChooseCourseBoard({
  courses,
  selectedCourse,
  setSelectedCourse,
}) {

  return (
    <div className="col-span-2">
          <HeaderComponent
            title="Step 1: Choose Your Course"
            description="Browse and select from our curated training programs"
            bgcolor="bg-gradient-to-br from-purple-50 to-indigo-50"
            icon={<LucideBookOpen className="text-white" size={20}/>}
            colorTheme="gradient-purple"
          >
            <div className="space-y-4 max-h-[500px] overflow-y-auto pr-2">
                {courses.map((course, index) => (
                    <SelectCourseCard
                      key={course.title}   
                      {...course}
                      index={index}
                      selected={selectedCourse?.title === course.title}
                      onClick={() => setSelectedCourse(course)}
                    />
                  ))}

            </div>
          </HeaderComponent>
        </div>
  );
};
